import {
  CardanoIcon,
  CoinbaseIcon,
  LeatherIcon,
  MetamaskIcon,
  OkxIcon,
  ParticleIcon,
  PetraIcon,
  PhantomIcon,
  StarkNetIcon,
  TonIcon,
  UnisatIcon,
  WalletConnectIcon
} from '@/components';
import { ExtendedWalletType, WalletType } from '@/utils/wallet/types';
export const NETWORK_TYPE_OPTIONS = [
  {
    value: WalletType.EVM,
    label: 'EVM Compatible Networks',
    description: 'Ethereum, Fantom, Polygon, Avalanche, etc.'
  },
  { value: WalletType.BITCOIN, label: 'Bitcoin' },
  { value: WalletType.SOLANA, label: 'Solana' },
  { value: WalletType.APTOS, label: 'Aptos' },
  { value: WalletType.TON, label: 'TON' },
  { value: WalletType.StarkNet, label: 'StarkNet' },
  { value: WalletType.Cardano, label: 'Cardano' }
];

export const NETWORK_TYPE_DISPLAY = {
  [WalletType.EVM]: 'EVM',
  [WalletType.BITCOIN]: 'Bitcoin',
  [WalletType.SOLANA]: 'Solana',
  [WalletType.APTOS]: 'Aptos',
  [WalletType.TON]: 'TON',
  [WalletType.PARTICLE]: 'Particle',
  [WalletType.OKX]: 'Okx',
  [WalletType.Coinbase]: 'Coinbase',
  [WalletType.Cyber]: 'Cyber',
  [WalletType.WALLETCONNECT]: 'WalletConnect',
  [WalletType.StarkNet]: 'StarkNet',
  [WalletType.Cardano]: 'Cardano'
};

export const WalletIconByType = {
  [WalletType.EVM]: MetamaskIcon,
  [WalletType.BITCOIN]: LeatherIcon,
  [WalletType.SOLANA]: PhantomIcon,
  [WalletType.APTOS]: PetraIcon,
  [WalletType.TON]: TonIcon,
  [WalletType.PARTICLE]: ParticleIcon,
  [WalletType.OKX]: OkxIcon,
  [WalletType.Coinbase]: CoinbaseIcon,
  [WalletType.Cyber]: null,
  [WalletType.WALLETCONNECT]: WalletConnectIcon,
  [WalletType.StarkNet]: StarkNetIcon,
  [WalletType.Cardano]: CardanoIcon,
  [ExtendedWalletType.UNISAT]: UnisatIcon,
  [ExtendedWalletType.OKXBTC]: OkxIcon
};
